import { getCookieSuffix } from './getEnvironment';

export const ANONYMOUS_USER_ID = 'ANONYMOUS';
export const CARTWHEEL_COOKIE_NAME = 'cartwheelUserID';

export function createAnomymousUserCookieIfNeeded() {
  const suffix = getCookieSuffix();
  if (!document.cookie.includes(`${CARTWHEEL_COOKIE_NAME}${suffix}=`)) {
    document.cookie = `${CARTWHEEL_COOKIE_NAME}${suffix}=${ANONYMOUS_USER_ID}; domain=${
      window.location.hostname.includes('localhost')
        ? 'localhost'
        : '.getcartwheel.com'
    }; path=/; secure; samesite`;
  }
}
